import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Layout } from 'antd';
import { Modal as ModalMobile } from 'antd-mobile';
import * as SignalR from '@aspnet/signalr';
import HomeFacilityCarousel from '../../modules/ThemeOne/HomeFacilityCarousel';
import HomeDiningCarousel from '../../modules/ThemeOne/HomeDiningCarousel';
import HomeDevaranaCarousel from '../../modules/ThemeOne/HomeDevaranaCarousel';
import HomeHeaderMenu from '../../modules/ThemeOne/HomeHeaderMenu';
import HomeHotelEvent from '../../modules/ThemeOne/HomeHotelEvent';
import HomeExperience from '../../modules/ThemeOne/HomeExperience';
import HomeFnbOffer from '../../modules/ThemeOne/HomeFnbOffer';
import HomeShoppingOffer from '../../modules/ThemeOne/HomeShoppingOffer';
import HomeSpaOffer from '../../modules/ThemeOne/HomeSpaOffer';
import { Markup } from 'interweave';
import IdleTimer from 'react-idle-timer';

const { Content } = Layout;
const REACT_APP_SIGNALR_URL = `${process.env.REACT_APP_STAYMENU_API_URL}/stayMenuHub`;
const confirmAlert = ModalMobile.alert;

@inject(
    'VersionStore',
    'templateStore',
    'CmsLanguageStore',
    'popupStore',
    'webSettingStore',
    'loginStore',
    'CmsFacilityHotelStore',
    'CmsEventHotelStore',
    'homeSpecialOfferStore',
    'homeRetailOfferStore',
    'homeSpaOfferStore',
    'CmsDiningStore',
    'CmsDevaranaStore',
    'CmsExperienceStore',
)
@observer
class HomeThemeOne extends Component {
    constructor(props) {
        super(props)
        this.state = {
            data: ['1', '2', '3']
        }
    }

    componentDidMount() {
        const roomNo = this.props.loginStore.getRoomNo();
        if (!roomNo) {
            this.props.history.push('/login');
        }

        this.props.loginStore.authenticateGuest().then(response => {
            if (!response) {
                this.props.history.push('/login');
            }
        });

        this.props.CmsFacilityHotelStore.getAllByLanguage();
        this.props.CmsDiningStore.getAllByLanguage();
        this.props.CmsDevaranaStore.getAllByLanguage();
        this.props.CmsEventHotelStore.getAllByLanguage();
        this.props.CmsExperienceStore.getAllByLanguage();
        this.props.homeSpecialOfferStore.initAvailable();
        this.props.homeRetailOfferStore.initAvailable();
        this.props.homeSpaOfferStore.initAvailable();
        this.props.CmsLanguageStore.getActives().then(() => {
            this.props.templateStore.getActive().then(() => {
                this.props.webSettingStore.getData().then(() => {
                    const { activeTemplate } = this.props.templateStore;
                    const { data: webSettting } = this.props.webSettingStore;

                    if (webSettting) {
                        this.props.popupStore.getByModuleName('HOME').then(resp => {
                            if (resp) {
                                const homePopupShown = window.localStorage.getItem('homePopupShown');
                                const homePopupTitle = window.localStorage.getItem('homePopupTitle');
                                const homePopupDescription = window.localStorage.getItem('homePopupDescription');

                                if (!homePopupShown) {
                                    this.showHomePopup(resp, activeTemplate);
                                } else {
                                    if (homePopupTitle !== resp.title || homePopupDescription !== resp.description) {
                                        this.showHomePopup(resp, activeTemplate);
                                    }
                                }
                            }

                        });
                    }
                });
            });
        });

        let connection = new SignalR.HubConnectionBuilder().withUrl(REACT_APP_SIGNALR_URL).build();
        connection.start().catch(function (err) { return console.error(err.toString()); });
        connection.on(`SignalR_SyncData`, () => { window.location.reload(true); });
    }

    componentWillUnmount() {
    }

    showHomePopup = (resp, activeTemplate) => {
        if (resp) {
            if (resp.title) {
                confirmAlert(
                    <div style={{
                        fontFamily: activeTemplate.templateSetting.label.fontFamily,
                        color: activeTemplate.templateSetting.label.color,
                        fontSize: activeTemplate.templateSetting.label.fontSize,
                        lineHeight: `${activeTemplate.templateSetting.label.fontSize + 2}px`
                    }}>
                        <span>{resp.title}</span>
                    </div>,
                    <div style={{
                        fontFamily: activeTemplate.templateSetting.text.fontFamily,
                        color: activeTemplate.templateSetting.text.color,
                        fontSize: activeTemplate.templateSetting.text.fontSize,
                        lineHeight: `${activeTemplate.templateSetting.text.fontSize + 8}px`
                    }}>
                        <Markup content={resp.description} />
                    </div>,
                    [
                        {
                            text: <span style={{
                                fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                color: activeTemplate.templateSetting.label.color,
                                fontSize: activeTemplate.templateSetting.label.fontSize,
                                lineHeight: `${activeTemplate.templateSetting.label.fontSize + 2}px`
                            }}>OK</span>,
                            onPress: () => {
                                window.localStorage.setItem('homePopupShown', true);
                                window.localStorage.setItem('homePopupTitle', resp.title);
                                window.localStorage.setItem('homePopupDescription', resp.description);
                            }
                        }
                    ]);
            }
        }
    }

    checkSmVersion = () => {
        this.props.VersionStore.check().then(resp => {
            if (!resp) {
                const { activeTemplate } = this.props.templateStore;
                const { data: webSettting } = this.props.webSettingStore;

                confirmAlert(
                    <div
                        style={{
                            fontFamily: activeTemplate.templateSetting.label.fontFamily,
                            color: activeTemplate.templateSetting.label.color,
                            fontSize: activeTemplate.templateSetting.label.fontSize,
                            lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                        }}>
                        <span>Info</span>
                    </div>,
                    <div
                        style={{
                            fontFamily: activeTemplate.templateSetting.text.fontFamily,
                            color: activeTemplate.templateSetting.text.color, fontSize: activeTemplate.templateSetting.text.fontSize,
                            lineHeight: `${activeTemplate.templateSetting.text.fontSize + 6}px`, textAlign: 'center'
                        }}>
                        <span>New version has been released. Please refresh the page.</span>
                    </div>, [
                    {
                        text:
                            <span
                                style={{
                                    fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                    color: activeTemplate.templateSetting.label.color,
                                    fontSize: activeTemplate.templateSetting.label.fontSize,
                                    lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                                }}
                            >
                                {webSettting.okText}
                            </span>,
                        onPress: () => {
                            window.location.reload(true);
                        }
                    }
                ]);
            }
        });
    }

    render() {
        const history = this.props.history;

        return (
            <Layout>
                <IdleTimer ref={ref => { this.idleTimer = ref }} timeout={1000 * 5} onIdle={this.checkSmVersion} debounce={250} />
                <Content className='stm-padding-bottom-100 stm-background-white'>
                    <HomeHeaderMenu history={history} />

                    <HomeFacilityCarousel history={history} />

                    <HomeDiningCarousel history={history} />

                    <HomeDevaranaCarousel history={history} />

                    <HomeHotelEvent history={history} />

                    <HomeExperience history={history} />

                    <HomeFnbOffer history={history} />

                    <HomeShoppingOffer history={history} />

                    <HomeSpaOffer history={history} />

                </Content>
            </Layout>
        )
    }
}

export default (HomeThemeOne)